<div class="header">
    <h1 class="tracking-heading">Parcel Number: <span class="number">{{ trackingNumber }}</span></h1>
</div>
